import "./sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { ConvexReactClient } from "convex/react";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App.tsx";
import { ErrorBoundary } from "./ErrorBoundary.tsx";

import { scan } from "react-scan"; // must be imported before React and React DOM

scan({
  enabled: true,
});

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }: { resetError: () => void }) => (
        <div className="flex min-h-screen items-center justify-center bg-background">
          <div className="max-w-md p-6 text-center">
            <h1 className="mb-4 text-2xl font-bold text-destructive">
              Something went wrong
            </h1>
            <p className="mb-4 text-muted-foreground">
              An unexpected error occurred. Our team has been notified.
            </p>
            <button
              onClick={() => resetError()}
              className="rounded bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
            >
              Try again
            </button>
          </div>
        </div>
      )}
      showDialog
    >
      <ErrorBoundary>
        <ClerkProvider
          publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}
        >
          <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
            <App />
          </ConvexProviderWithClerk>
        </ClerkProvider>
      </ErrorBoundary>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
